import React from 'react';
import { Translation } from 'react-i18next';
import { Typography } from 'antd';
import Logger from '../../../../../lib/Logger';
import { Link } from 'react-router-dom';
import useFetchSignedUrl from '../../../hooks/useFetchSignedUrl';
import imageLoading from './../../../assets/images/image-loading.png';
import { withRouter } from 'react-router';
import { StateCardTag } from '../../../elements/components/Tags';

const { Paragraph, Title } = Typography;

const LearningAdminModuleCard = ({
  item,
  getSignedUrl,
  imageUrl,
  setActiveImage,
  imagePath,
  history,
  ...props
}) => {
  useFetchSignedUrl(imagePath, imageUrl, getSignedUrl, setActiveImage);

  return (
    <Translation>
      {(t) => (
        <>
          {item && (
            <div className='learning-module-card' key={item.id}>
              <div className='module-card-image-wrapper-2'>
                <img
                  alt='media-module'
                  className='cursor-pointer'
                  src={imageUrl ?? imageLoading}
                  style={{}}
                />
              </div>
              <div className='learning-module-card-content'>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Title
                    level={5}
                    style={{ margin: 0 }}
                    className='cursor-pointer'
                  >
                    {item.title}
                  </Title>
                  <StateCardTag value={0} />
                </div>

                <Paragraph
                  ellipsis={{
                    rows: 2,
                  }}
                >
                  {item.description}
                </Paragraph>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Link to={null} style={{ textDecoration: 'underline' }}>
                    {t('learning_module_continue_module')}
                  </Link>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </Translation>
  );
};

export default withRouter(LearningAdminModuleCard);

Logger.log('silly', `LearningAdminModuleCard loaded.`);
